import { listDeviceStatus, listStatus } from "../../utils/helper";
import { useResponsive } from "../../hooks/mediaQuery";
import { useTranslation } from "react-i18next";

const Annotate = () => {
    const { isXs } = useResponsive();
    const { t } = useTranslation();
    return (
        <div className="p-2 bg-gray-50 rounded-lg">
            <div className="annotate flex gap-2 mb-2">
                {listDeviceStatus.map((status) => (
                    <div key={status.value} className="flex items-center gap-1">
                        <div className={`dot ${status.color}`}></div>
                        <span className={`${isXs ? 'text-xs' : 'text-sm'} text ${status.color}`}>{t(`${status.label}`)}</span>
                    </div>
                ))}
            </div>
            <div className="annotate flex gap-1">
                {listStatus.map((frame) => (
                    <div key={frame.value} className={`frame ${isXs ? 'flex-1' : ''} ${frame.color}`}>
                        <p className={`${isXs ? 'text-xs' : 'text-sm'}`}>{t(`${frame.label}`)}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Annotate;